





















import { Component, Prop, Vue } from 'vue-property-decorator';
import PageBanner from '@/components/PageBanner.vue';
import OverlappingTextImage from '@/components/OverlappingTextImage.vue';
import AboutText from '@/components/AboutText.vue';
import WhatWeDo from '@/components/WhatWeDo.vue';
import Mission from '@/components/Mission.vue';
import Emons from '@/components/Emons.vue';
import SingleService from '@/components/SingleService.vue';
import LocationDetails from '@/components/LocationDetails.vue';
import ContactUs from '@/components/ContactUs.vue';
import ResourcesTab from '@/components/ResourcesTab.vue';
import Team from '@/components/Team.vue';
import Location from '@/components/Locations.vue';
import InquiryForm from '@/components/InquiryForm.vue';
import PrivacyPolicy from '../components/PrivacyPolicy.vue';
import CertificationLogo from '../components/CertificationLogo.vue';
import { getImgUrl } from '../utils/dummy';

import {
  TimelineMax,
  CSSPlugin,
  CSSRulePlugin,
  ScrollToPlugin,
  Draggable,
  Power4,
  Expo,
  Elastic,
  Bounce,
  onComplete,
  clearProps,
  TweenMax,
  fromTo
} from 'gsap/all';
import IncoTerms from '../components/IncoTerms.vue';

@Component({
  name: 'BasicPage',
  components: {
    PageBanner,
    // text_block: AboutText,
    overlapping_text_image: OverlappingTextImage,
    double_image_title_text_cta: WhatWeDo,
    title_text_image: Mission,
    title_subtitle_text_image_cta: Emons,
    title_multi_richtext_image_list: SingleService,
    contact_form: ContactUs,
    source_block: ResourcesTab,
    team_block: Team,
    location_block: Location,
    inquiry_form: InquiryForm,
    data_table: IncoTerms,
    richtext: PrivacyPolicy,
    logo_list: CertificationLogo
  }
})
export default class BasicPage extends Vue {
  getImgUrl = getImgUrl;
  @Prop() pageData: any;
}
